import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Pre-register the FCM service worker at app startup, before any React
 * component mounts. This gives the service worker a head start on activation
 * so that when Firebase getToken() later calls PushManager.subscribe(), the
 * service worker is already active and registered.
 *
 * Without this pre-registration, there is a race condition between:
 * 1. The service worker registration completing and transitioning to 'activated'
 * 2. Firebase's internal token-manager.ts calling PushManager.subscribe()
 *
 * The ensureServiceWorker() function in fcm.js also registers the SW, but this
 * early registration ensures it's already in the browser cache by the time
 * any component needs it.
 *
 * Additionally, this sends the Firebase config to the service worker via
 * postMessage so the SW can initialize with the same config as the main app
 * (instead of using hardcoded values).
 */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('📱 [Pre-registration] SW registered:', registration.scope);

      // Send Firebase config to the service worker so it stays in sync
      // with the main app's .env configuration.
      if (registration.active || registration.waiting) {
        const target = registration.active || registration.waiting;
        target.postMessage({
          type: 'FCM_CONFIG',
          config: {
            apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
          },
        });
      }

      // If there's a waiting worker (e.g., after an update), activate it immediately
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    })
    .catch((err) => {
      console.warn('📱 [Pre-registration] SW registration failed:', err.message);
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
